type RequiredHiddenInputProps = {
  isRequired: boolean;
  hasValue: boolean;
};

export function RequiredHiddenInput({
  isRequired,
  hasValue,
}: RequiredHiddenInputProps) {
  return (
    <input
      required={isRequired}
      value={hasValue ? 'filled' : ''}
      onChange={() => undefined}
      tabIndex={-1}
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        opacity: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
    />
  );
}
